/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import PropTypes from 'prop-types';

// atoms
import Subtitle from '../../atoms/subtitle';
import Button from '../../atoms/button';
import Input from '../../atoms/input';

// style
import './style.scss';

const UpdateUserOrganism = ({
  cpf,
  setCpf,
  mobilePhone,
  setMobilePhone,
  submitForm,
  errorCpf,
  errorMobilePhone,
  errorGeneric,
  disabled,
  loading,
  customValidationCPF,
  customValidationPhone
}) => {
  return (
    <>
      <Subtitle>Para continuar, confirme os seus dados.</Subtitle>
      <form noValidate onSubmit={submitForm}>
        <label className="confirm-label" htmlFor="cpf">
          CPF:
        </label>
        <Input
          id="cpf"
          name="cpf"
          type="tel"
          format="cpf"
          placeholder="000.000.000-00"
          maxLength="14"
          value={cpf}
          setValue={setCpf}
          error={errorCpf}
          invalid={!!errorCpf}
          customValidation={customValidationCPF}
        />
        <label className="confirm-label" htmlFor="mobilePhone">
          Telefone:
        </label>
        <Input
          id="mobilePhone"
          name="mobilePhone"
          type="tel"
          format="phone"
          placeholder="(00) 00000 0000"
          maxLength="15"
          value={mobilePhone}
          setValue={setMobilePhone}
          error={errorMobilePhone}
          invalid={!!errorMobilePhone}
          customValidation={customValidationPhone}
        />
        <div
          className={`generic-error error-label ${
            errorGeneric ? 'visible' : ''
          }`}
        >
          {errorGeneric}
        </div>
        <Button disabled={disabled} loading={loading} submit>
          Continuar
        </Button>
      </form>
    </>
  );
};

UpdateUserOrganism.defaultProps = {
  cpf: '',
  setCpf: () => {},
  mobilePhone: '',
  setMobilePhone: () => {},
  submitForm: () => {},
  errorCpf: '',
  errorMobilePhone: '',
  errorGeneric: '',
  disabled: true,
  loading: false,
  customValidationCPF: () => {},
  customValidationPhone: () => {}
};

UpdateUserOrganism.propTypes = {
  cpf: PropTypes.string,
  setCpf: PropTypes.func,
  mobilePhone: PropTypes.string,
  setMobilePhone: PropTypes.func,
  submitForm: PropTypes.func,
  errorCpf: PropTypes.string,
  errorMobilePhone: PropTypes.string,
  errorGeneric: PropTypes.string,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  customValidationCPF: PropTypes.func,
  customValidationPhone: PropTypes.func
};

export default UpdateUserOrganism;
